export class Solution {
  name: string;
  iconepath: string;
  activities: string[];
  marque: string;
  usecase: string;
  descriptions: string[];
  benefits: string[];
  selected: boolean;
  ios: string;
  android: string;
}
